import {createImageUrlBuilder} from '@sanity/image-url'
import {useMemo} from 'react'

import {useVersionedClient} from '../../versionedClient'

const tutorialsProjectConfig = {
  projectId: '3do82whm',
  dataset: 'next',
}

export interface Guide {
  _type?: string
  slug?: {current: string}
  presenter?: {
    name?: string
  }
}

export interface FeedItem {
  _id: string
  title?: string
  poster?: string
  category?: string
  guideOrTutorial?: Guide
  externalLink?: string
  presenter?: {
    name?: string
  }
  hasVideo?: boolean
}

export function useDataAdapter() {
  const versionedClient = useVersionedClient()
  return useMemo(
    () => ({
      getFeed: (templateRepoId: string) => {
        const url = templateRepoId
          ? `/addons/dashboard?templateRepoId=${templateRepoId}`
          : '/addons/dashboard'
        return versionedClient.observable.request<{items: FeedItem[]}>({
          url,
          tag: 'dashboard.sanity-tutorials',
          withCredentials: false,
        })
      },
      urlBuilder: createImageUrlBuilder(tutorialsProjectConfig),
    }),
    [versionedClient],
  )
}
